
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/au/submission-success",
      function () {
        return require("private-next-pages/au/submission-success/index.jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/au/submission-success"])
      });
    }
  